import React from 'react';

import { useDynamicDataExampleWidgetLazyQuery } from 'generated/graphql';



export interface IData {
  order: string;
}

export function useLazyQuery(queryOrder: boolean) {
  const [fnQuery, tuple] = useDynamicDataExampleWidgetLazyQuery({});

  const fnWrappedQuery = React.useCallback(
    (id: string) => {
      fnQuery({
        variables: {
          id,
          queryOrder
        }
      });
    },
    [fnQuery, queryOrder]
  );

  const wrappedTuple = React.useMemo(
    () => {
      const data: IData = {
        order: tuple.data?.sendGridOrder
          ? JSON.stringify(tuple.data?.sendGridOrder, null, 2)
          : JSON.stringify(tuple.data?.sendGridReturnAuthorization, null, 2)
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );

  return React.useMemo(
    () => [
      fnWrappedQuery,
      wrappedTuple
    ] as const,
    [
      fnWrappedQuery,
      wrappedTuple
    ]
  );
}
